module.exports = __webpack_public_path__ + "static/sample-projects-16-ca501b9935737df060366fc8077f0f48.png";